<template>
    <ul class="radio-list clearfix" id="radioList" :class="{ 'radio-list__disabled': disabled }">
        <li
            class="radio-list__item clearfix"
            v-for="(item, index) in dataList"
            :key="index"
            @click="handleChange(item.value)"
            :class="{
                active: value === item.value,
                inactive: disabled
            }"
        >
            <span class="radio-list__item__icon">
                <span></span>
            </span>
            <span class="radio-list__item__label" v-if="isText">{{ $t(item.label) }}</span>
            <span class="radio-list__item__label" v-else>{{ item.label }}</span>
        </li>
    </ul>
</template>
<script>
// Component create radio list
export default {
    name: 'radio',
    // props: ['value', 'dataList', 'disabled'],
    props: {
        value: {},
        dataList: {},
        disabled: {
            default: function () {
                return false;
            },
            type: Boolean
        },
        isText: {
            default: function () {
                return false;
            },
            type: Boolean
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    components: {},
    data: function () {
        return {};
    },
    methods: {
        handleChange: function (value) {
            if (!this.disabled) {
                this.$emit('change', value);
            }
        }
    }
};
</script>

<style lang="scss">
$colorRadio: #868ba1;
.radio-list {
    margin-bottom: 0px;
    //padding-left: 10px;
    &__item {
        $item: &;
        float: left;
        margin-right: 30px;
        cursor: pointer;
        padding-left: 30px;
        position: relative;

        &:last-child {
            margin: 0;
        }
        &.inactive {
            cursor: not-allowed;
        }

        &__icon {
            @include compatible(box-sizing, border-box);

            display: block;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            border: 2px solid rgba(0, 0, 0, 0.54);
            background: #ffffff;
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -10px;
        }

        &__label {
            @include regular-font(15px);
            color: #343a40;
            display: block;
            margin-left: 10px;
            line-height: 42px;
        }

        &.active {
            #{$item}__icon {
                border-color: $colorRadio;
                span {
                    display: block;
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    background: $colorRadio;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-top: -5px;
                    margin-left: -5px;
                }
            }
        }
    }
}
</style>
